import React from 'react'
import PropTypes from 'prop-types'

export const Circle = ({
  radius = 0.5,
  segments = 16,
  color = 0xff0000,
  ...props
}) => {
  return (
    <mesh {...props}>
      <circleGeometry
        attach="geometry"
        args={[radius, segments]}
      />
      <meshBasicMaterial attach="material" color={color} />
    </mesh>
  )
}

Circle.propTypes = {
  radius: PropTypes.number,
  segments: PropTypes.number
}

export default Circle
